import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

export const DatabaseIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      <path
        d="M22 4.14286V6.10714C22 7.83818 17.7448 9.25 12.5 9.25C7.25519 9.25 3 7.83818 3 6.10714V4.14286C3 2.41182 7.25519 1 12.5 1C17.7448 1 22 2.41182 22 4.14286ZM22 8.5625V12.9821C22 14.7132 17.7448 16.125 12.5 16.125C7.25519 16.125 3 14.7132 3 12.9821V8.5625C5.04102 9.98661 8.77668 10.6496 12.5 10.6496C16.2233 10.6496 19.9589 9.98661 22 8.5625ZM22 15.4375V19.8571C22 21.5882 17.7448 23 12.5 23C7.25519 23 3 21.5882 3 19.8571V15.4375C5.04102 16.8616 8.77668 17.5246 12.5 17.5246C16.2233 17.5246 19.9589 16.8616 22 15.4375Z"
        fill="currentColor"
      />
    </IconBase>
  );
};

export default DatabaseIcon;
